module.exports = {
	"pathContext": {
		"path": "/shop/merino-beanie/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-beanie.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-beanie.json
// module chunks = 30941037784260